import { rankingData } from '@/mocks/home';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">热度榜单</h2>
          <div className="w-12 h-1 bg-accent-500 mx-auto rounded-full"></div>
          <p className="text-sm text-foreground-500 mt-3">实时更新 · 全网热播排行</p>
        </div>
        <div className="max-w-2xl mx-auto space-y-3">
          {rankingData.map((item) => (
            <a key={item.id} href="#" className="flex items-center gap-4 bg-background-50 rounded-xl p-4 border border-background-200/70 hover:border-accent-300 transition-all duration-200 cursor-pointer group">
              <div className={`w-10 h-10 rounded-full flex items-center justify-center font-heading font-bold text-sm flex-shrink-0 ${
                item.rank === 1 ? 'bg-primary-500 text-background-50' :
                item.rank === 2 ? 'bg-accent-500 text-background-50' :
                item.rank === 3 ? 'bg-secondary-500 text-background-50' :
                'bg-background-200 text-foreground-600'
              }`}
              >
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors truncate">{item.title}</div>
                <div className="text-xs text-foreground-500">{item.type}</div>
              </div>
              <div className="text-xs font-medium text-accent-600 whitespace-nowrap">{item.heat}</div>
              <div className="w-6 h-6 flex items-center justify-center text-foreground-300 group-hover:text-primary-500 transition-colors flex-shrink-0">
                <i className="ri-play-circle-line text-lg"></i>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}